// AUTO-GENERATED by scripts/gen-component-map.mjs - Do not edit manually
//
// Layout-only component map (banner/header/footer/fab + per-app overrides).
// Imported by the client layout wrapper so it does NOT pull the full
// component-map (all content modules) into the client bundle, while still
// honoring per-app layout overrides (custom beats shared).
//
// Generated on: 2026-09-30T15:57:29.608Z

import { ComponentType } from 'react';

import { BannerComponent } from '@/app/_components/shared/banner';
import { HeaderComponent } from '@/app/_components/shared/header';
import { FooterComponent } from '@/app/_components/shared/footer';
import { FabComponent } from '@/app/_components/shared/fab';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyComponent = ComponentType<any>;

export const LAYOUT_COMPONENT_MAP: Record<string, AnyComponent> = {
  'banner': BannerComponent,
  'header': HeaderComponent,
  'footer': FooterComponent,
  'fab': FabComponent,
};
